---
title: Distortion
description: "A distortion device: a drive, a tone, a mix and an output, a panel that draws the transfer curve, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-distortion" />

Bends the sound. The more the drive, the more the peaks round off. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="distortion" kind="device" />

## Controls

<DeviceControls device="distortion">
<Control id="driveDb">How hard the signal is pushed into the clip.</Control>
<Control id="toneHz">Closes the highs after the clip.</Control>
<Control id="mix">The balance of the distorted signal and the clean one.</Control>
<Control id="outputDb">The level of the output.</Control>
</DeviceControls>

## Panel

The panel draws the transfer curve, the output for each input, against the straight line of a clean sound. `softClip(input, drive)` is the clip and `distortionCurve(state)` is the whole curve with the mix and the output.

<DeviceUsage name="distortion" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The drive is a gain before one fixed soft-clip table, so turning it never rebuilds the table. The shaper oversamples 4x to keep the clip from aliasing, which is the [latency](/docs/devices#latency) of the device.
